<app-ingredients-filters (onFilter)="onFilter($event)" [defaultFilters]="defaultFilters">
</app-ingredients-filters>

<mat-card class="add-button-container" *ngIf="!(ingredients | async).length">
  <h4>Nessun ingrediente trovato</h4>
  <button class="add-button" *ngIf="canAdd" mat-raised-button (click)="addIngredient()" color="primary">
    Aggiungi ingrediente
  </button>
</mat-card>

<div class="table-container" *ngIf="(ingredients | async).length">
  <table mat-table matSort [dataSource]="ingredients" multiTemplateDataRows matSortDisableClear matSortActive="name"
    matSortDirection="asc">

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Nome </th>
      <td mat-cell *matCellDef="let ingredient"> {{ ingredient.name }} </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Descrizione </th>
      <td mat-cell *matCellDef="let ingredient"> {{ ingredient.description }} </td>
    </ng-container>

    <!-- Addition Price Column -->
    <ng-container matColumnDef="additionPrice">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Prezzo agg. </th>
      <td mat-cell *matCellDef="let ingredient"> {{ ingredient.additionPrice | number : '1.2-2' }} <small>€</small></td>
    </ng-container>

    <!-- Minus Price Column -->
    <ng-container matColumnDef="minusPrice">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Prezzo diff. </th>
      <td mat-cell *matCellDef="let ingredient"> {{ ingredient.minusPrice | number : '1.2-2' }} <small>€</small></td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="add-icon-container">
        <button mat-mini-fab *ngIf="canAdd" matTooltip="Nuovo ingrediente"
          (click)="$event.stopPropagation(); addIngredient()" color="primary">
          <mat-icon>add</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row" class="modify-icon-container">
        <ng-container *ngIf="canEdit">
          <button mat-icon-button (click)="$event.stopPropagation(); editIngredient(row)">
            <mat-icon matTooltip="Modifica">create</mat-icon>
          </button>
        </ng-container>

        <!-- <button mat-icon-button (click)="$event.stopPropagation(); deleteIngredient(ingredient)">
          <mat-icon matTooltip="Elimina">delete</mat-icon>
        </button> -->
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="editIngredient(row)"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="pageSizeOptions"
  [pageSize]="pageSizeOptions[0]"
  [length]="total | async">
  </mat-paginator>
</div>
